import { useState } from "react";
import { useLang } from "@/i18n/LangContext";
import { projects, projectFilters } from "@/data/projects";
import { ProjectCard } from "@/components/ProjectShowcase";
import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

export default function Projects() {
  const { t, lang } = useLang();
  const [filter, setFilter] = useState("all");
  const list = filter === "all" ? projects : projects.filter((p) => p.filter === filter);

  return (
    <>
      <Seo page="projects" />
      <section className="bg-ink bg-grid-dark pt-[140px] pb-14 lg:pt-[180px]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="text-xs font-semibold tracking-[0.25em] text-electric">{t("work.eyebrow")}</p>
            <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight">{t("projectsPage.title")}</h1>
            <p className="mt-5 max-w-2xl text-base sm:text-lg text-steel leading-relaxed">{t("projectsPage.sub")}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-9 flex flex-wrap gap-2.5" role="tablist">
              {projectFilters.map((f) => (
                <button
                  key={f.id}
                  data-testid={`filter-${f.id}`}
                  onClick={() => setFilter(f.id)}
                  className={`rounded-full border px-5 py-2.5 text-xs font-semibold tracking-wide transition-colors ${
                    filter === f.id ? "border-electric bg-gradient-to-r from-dblue to-electric text-white" : "border-white/15 text-steel hover:text-white"
                  }`}
                >
                  {f.label[lang]}
                </button>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
      <section className="bg-white text-ink py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-8 md:grid-cols-2">
            {list.map((p, i) => (
              <ProjectCard key={p.slug} p={p} index={i} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
